const api = 'https://backend.relab.family/api'

export default api